import React from 'react';
import { useChild } from '../contexts/ChildContext';

/**
 * Pill button that re-opens the child selection modal — used on every parent
 * page that displays a single child's data (Performance, Program, Student
 * Assignments). Self-hides when the parent has 0 or 1 children, since the
 * picker would be a no-op there.
 *
 * Visual: filled blue pill matching the app's other primary CTAs (Hedef Ata,
 * Programını İncele, etc.) plus a swap icon so the action reads at a glance.
 */
const F = { fontFamily: 'Inter' } as const;

const ChildSwitcherButton: React.FC<{ className?: string }> = ({ className }) => {
  const { children: kids, clearSelection, refresh } = useChild();
  if (kids.length < 2) return null;
  // Re-open the picker AND refresh the list so each child's avatar gets a
  // freshly signed URL — the initial ones expire after 1h and would otherwise
  // render broken for children who have a real profile photo.
  const onSwitch = () => { clearSelection(); refresh(); };
  return (
    <button
      onClick={onSwitch}
      title="Başka bir öğrenciyi görüntüle"
      className={`rounded-[12px] px-4 py-2 hover:opacity-90 flex items-center gap-2 ${className ?? ''}`}
      style={{ background: '#3973bf' }}
    >
      {/* Users icon — reads as "choose among your students" (matches mobile). */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
      <span style={{ ...F, fontSize: 13, fontWeight: 600, color: '#fff' }}>Öğrenci Değiştir</span>
    </button>
  );
};

export default ChildSwitcherButton;
